/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Warehouse_ReceiptsInputs */

const en_nav_warehouse_receipts = /** @type {(inputs: Nav_Warehouse_ReceiptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warehouse receipts`)
};

/**
* | output |
* | --- |
* | "Warehouse receipts" |
*
* @param {Nav_Warehouse_ReceiptsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_warehouse_receipts = /** @type {((inputs?: Nav_Warehouse_ReceiptsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Warehouse_ReceiptsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_warehouse_receipts(inputs)
});